/** State programs are not interchangeable with federal Tier II report-entry thresholds. */
export type ThresholdProgram = 'tier_ii' | 'ca_hmbp' | 'nj_crtk' | 'or_cr2k';
export type ThresholdQuantity =
  | { kind: 'amount'; value: number; unit: 'lb' | 'gal' | 'ft3'; physicalState?: string; conditions?: string }
  | { kind: 'presence' }
  | { kind: 'tpq' };
export interface StateThresholdDefinition {
  version: 1;
  sourceKey: string;
  program: ThresholdProgram;
  title: string;
  selector:
    | { kind: 'hazard_class'; system: 'DOT' | 'state'; classes: string[] }
    | { kind: 'material'; category: string }
    | { kind: 'list'; list: string; facilityCondition?: string }
    | { kind: 'program_review' };
  quantities: ThresholdQuantity[];
  conditions: string[];
  citation: string;
  /** Reviewed descriptions are not executable predicates. No guessed class/list membership. */
  evaluation: 'manual';
}
export type StateThresholdOutcome = 'not_applicable' | 'below_threshold' | 'reporting_required';
export interface StateThresholdReviewInput {
  outcome: StateThresholdOutcome;
  assessment: string;
  citation: string;
  filingPlan: string;
  entryKeys: string[];
}
export interface StateThresholdEntryOption {
  key: string;
  label: string;
  basis: 'compound' | 'mixture';
  included: boolean;
  detail: string;
  disabledReason?: string;
}
export interface StateThresholdReviewRecord extends StateThresholdReviewInput {
  fingerprint: string;
  reviewedBy: number;
  reviewedAt: string;
}
export interface StateThresholdReviewItem {
  ruleID: number;
  stateCode: string;
  reportingYear: number;
  definition: StateThresholdDefinition;
  fingerprint: string;
  review: StateThresholdReviewRecord | null;
  status: 'needs_review' | 'stale' | 'reviewed';
  issues: string[];
}
export const THRESHOLD_PROGRAM_LABELS: Record<ThresholdProgram, string> = {
  tier_ii: 'State Tier II requirements',
  ca_hmbp: 'California HMBP',
  nj_crtk: 'New Jersey CRTK',
  or_cr2k: 'Oregon CR2K',
};
export const thresholdEntryKey = (entry: { basis: string; productID?: number; casOrCategory?: string }) =>
  entry.basis === 'mixture' ? `product:${entry.productID}` : `chemical:${entry.casOrCategory}`;
